var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z",
    fill: "#0972D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17C11.45 17 11 16.55 11 16V12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12V16C13 16.55 12.55 17 12 17Z",
    fill: "#EFFBFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8C13 8.55228 12.5523 9 12 9V9C11.4477 9 11 8.55228 11 8V8C11 7.44772 11.4477 7 12 7V7C12.5523 7 13 7.44772 13 8V8Z",
    fill: "#EFFBFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoBlue);
export default __webpack_public_path__ + "static/media/Icon_Info_Blue.5869c778353651fe69fb658aaba7da38.svg";
export { ForwardRef as ReactComponent };